import React from 'react';

import { CONTRACT_APPRAISAL_CONTINGENCY } from '@/config/constants';
import { ClauseText } from './Components/ContractText';

interface Props {
  daysFromExecutionDate?: number;
  daysForAppraisalNegotiation?: number;
  appraisalContingency?: CONTRACT_APPRAISAL_CONTINGENCY;
}

const Appraisal = ({
  daysFromExecutionDate,
  daysForAppraisalNegotiation,
  appraisalContingency,
}: Props) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Appraisal Contingency
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          This Contract is not contingent upon the Property appraising for{' '}
          {appraisalContingency ===
          CONTRACT_APPRAISAL_CONTINGENCY.AT_LEAST_PURCHASE_PRICE ? (
            <ClauseText> least the Purchase Price.</ClauseText>
          ) : appraisalContingency ===
            CONTRACT_APPRAISAL_CONTINGENCY.AT_LEAST_LISTING_PRICE ? (
            <ClauseText> least the Listing Price.</ClauseText>
          ) : appraisalContingency ===
            CONTRACT_APPRAISAL_CONTINGENCY.AT_LEST_WITHIN_RANGE ? (
            <ClauseText>
              {' '}
              At least within the range of Purchase Price - Down payment
            </ClauseText>
          ) : (
            <ClauseText> No Appraisal Contingency</ClauseText>
          )}
        </li>
        <li>
          The Appraisal report must be completed within{' '}
          <ClauseText>{daysFromExecutionDate}</ClauseText> days of the executed
          date of this contract, not including the executed date of this
          contract.
        </li>
        <li>
          If the Property does not appraise at or above the Purchase Price,
          Buyer may terminate this Contract by providing written notice to
          Seller within <ClauseText>{daysForAppraisalNegotiation}</ClauseText>{' '}
          days after Buyer's receipt of the appraisal report, providing that the
          Appraisal Report is recieved within{' '}
          <ClauseText>{daysFromExecutionDate}</ClauseText> days from the date of
          execution of this Contract.
        </li>
        <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
          <li>
            If Buyer terminates this Contract under this provision within{' '}
            <ClauseText>{daysForAppraisalNegotiation}</ClauseText> days after
            Buyer's receipt of the appraisal report, the earnest money shall be
            returned to Buyer.
          </li>
          <li>
            If Buyer does not terminate this Contract under this provision
            within <ClauseText>{daysForAppraisalNegotiation}</ClauseText> days
            after Buyer's receipt of the appraisal report, the Contract shall
            proceed to Closing.
          </li>
          <li>
            If the Property appraises for less than the Purchase Price, Buyer
            may terminate this Contract or negotiate Purchase Price by providing
            written notice to Seller within{' '}
            <ClauseText>{daysForAppraisalNegotiation}</ClauseText> days after
            Buyer's receipt of the appraisal report.
          </li>
          <ol className="ml-4 text-black mb-2 text-base list-decimal list-inside text-bold">
            <li>
              Seller has <ClauseText>{daysForAppraisalNegotiation}</ClauseText>{' '}
              days not including the date of receipt of written notice of new
              Purchase Price to counter offer or accept.
            </li>
            <li>
              Both parties, Buyer and Seller are to be provided with a copy of
              the completed Appraisal Report.
            </li>
            <li>
              If either party prepares a reconsideration of value with
              comparable properties, the appraisal contingency timeline for any
              new appraisal report with a reconsideration of value is extended
              until reciept of the new appraisal report with a reconsideration
              of value.
            </li>
            <li>
              Upon receipt of an updated appraisal report without sufficient
              Appraier's Opinion of Value, after a reconsideration of value
              request, Buyer retains right to terminate the purchase contract
              according to the terms of the Appraisal Contingency and has{' '}
              <ClauseText>{daysForAppraisalNegotiation}</ClauseText> days upon
              receipt of the updated appraisal report to terminate the contract.
            </li>
            <li>
              Upon receipt of an updated appraisal report with sufficient
              Appraiser's Opinion of Value at or above Purchase price, after a
              reconsideration of value request, Buyer forgoes the right to
              terminate the purchase contract according to the terms of the
              Appraisal Contingency.
            </li>
          </ol>
        </ol>
      </ol>
    </div>
  );
};

export default Appraisal;
